import { createPaginationFilters } from '@/features/admin/helper/createPaginationFilters'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { SearchType } from '@/generated/Enumerations/SearchType_pb'
import { WorkingTimeModelSearchBy } from '@/generated/Enumerations/WorkingTimeModelSearchBy_pb'
import { WorkingTimeModelSortBy } from '@/generated/Enumerations/WorkingTimeModelSortBy_pb'
import {
    WorkingTimeModelFiltersDto,
    WorkingTimeModelFiltersDto_ColumnSearching,
} from '@/generated/Messages/Filters_pb'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

const createWorkingTimeModelsSearching = (
    searchText: string
): OmitDeepMessageFields<WorkingTimeModelFiltersDto_ColumnSearching>[] => [
    {
        searchBy: WorkingTimeModelSearchBy.NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    },
    {
        searchBy: WorkingTimeModelSearchBy.DESCRIPTION,
        searchText,
        searchType: SearchType.CONTAINS,
    },
]

export const workingTimeModelsQueryFilters = (
    deletedItemSelection: DeletedItemSelection,
    pageSize: number,
    page: number,
    sortByField: WorkingTimeModelSortBy,
    sortDirectionDesc: boolean,
    searchText: string
): Partial<OmitDeepMessageFields<WorkingTimeModelFiltersDto>> => ({
    deletedItemSelection,
    pagination: createPaginationFilters(pageSize, page),
    sorting: [
        {
            sortBy: sortByField,
            descending: sortDirectionDesc,
        },
    ],
    searching: createWorkingTimeModelsSearching(searchText.toLowerCase()),
})
